// One policy for the Next.js server and browser; independent of test/scoring rules.
export const WEBSITE_SLOW_REQUEST_MS = 5000;
export const WEBSITE_EVENTS_PER_MINUTE = 20;
export const WEBSITE_BOT = /bot\b|crawler|spider|HeadlessChrome|PhantomJS|lighthouse|playwright|puppeteer/i;
export const WEBSITE_REQUEST_ID = /^[a-zA-Z0-9_-]{8,64}$/;
